var productPage = {


	// ----- VARS ----- //
	elms: {
		body: $( 'html, body' ),
		container: $( '.product-page' ),
		items: $( '.product-page .product' ),
		more: $( '.pagination-button' ),
		template: $( '#product-template' )
	},

	numItems: 0,

	productApiUrl: $( '.product-page' ).data( 'product-api-url' ),
	productBaseUrl: $('.product-page').data('product-base-url'),
	productLanguageNodeId: $('.product-page').data('product-language-node-id'),
	productSearchType: $( '.product-page' ).data( 'product-search-type' ),
	productSearchValue: $( '.product-page' ).data( 'product-search-value' ),
	productResultCount: $( '.product-page' ).data( 'product-result-count' ),
	productResultLimit: $( '.product-page' ).data( 'product-result-limit' ),

	state: undefined,

	template: undefined,


	// ----- CONSTANTS ----- //
	STATE_LOADING: 'loading',
	STATE_READY: 'ready',
	STYLE_LOADING: 'loading',


	// ----- FUNCTIONS ----- //
	init: function () {
		//console.log( 'productPage: init' );

		if ( productPage.elms.container.length > 0 ) {

			productPage.handleLoad();

			productPage.processItems( productPage.elms.items );
			productPage.processTemplate();

			productPage.numItems = productPage.elms.items.length;
			productPage.toggleMore();

			productPage.changeState( productPage.STATE_READY );

			// Add Listeners
			productPage.elms.more.on( 'click', productPage.onMoreClick );

		}

	},

	handleLoad: function() {
		var pageUrl = window.location.href;
		var pageUrl_split = pageUrl.split(productPage.productBaseUrl)[1];
		if (pageUrl_split == undefined) {
			pageUrl += '/';
			pageUrl_split = pageUrl.split(productPage.productBaseUrl)[1];
		}

        if (pageUrl_split !== undefined && pageUrl_split !== '' && pageUrl_split !== '/' && pageUrl_split !== '.html') {
			var filter = pageUrl_split.split('/');
			var filter_type = filter[filter.length - 2];
			var filter_target = filter[filter.length - 1];

			var item_target = $('[data-product-search-type="' + filter_type + '"]').find('[data-product-search-value="' + filter_target + '"]');

			if (item_target.length) {
				var item_copy = item_target.text();
				$('.searchDd-main').text(item_copy);
			}
		}
	},

	changeState: function( state ) {
		//console.log( "productPage: changeState", state );

		productPage.state = state;

		if ( productPage.state === productPage.STATE_LOADING )
			productPage.elms.more.addClass( productPage.STYLE_LOADING );
		else
			productPage.elms.more.removeClass( productPage.STYLE_LOADING );

	},

	loadItems: function() {
		//console.log( "productPage: loadItems" );

		$.ajax( productPage.productApiUrl, {
		    data: {
                languageNodeId: productPage.productLanguageNodeId,
				productSearchType: productPage.productSearchType,
				productSearchValue: productPage.productSearchValue,
				skip: productPage.numItems,
				take: productPage.productResultCount
			},
			dataType: 'JSON',
			method: 'GET'
		} ).done( function( data, textStatus, jqXHR ) {
			//console.log( "productPage: loadItems: done:", textStatus );

			productPage.processData( data );
			productPage.changeState( productPage.STATE_READY );

		} ).fail( function( jqXHR, textStatus, errorThrown ) {
			//console.warn( "productPage: loadItems: fail:", textStatus );

		} );

	},

	processData: function( data ) {
		//console.log( 'productPage: processData', data );

		// Get Scroll Position Before Appending New Items
		var currentTop = productPage.elms.body.scrollTop();
		var newTop = productPage.elms.container.offset().top + productPage.elms.container.height() - 10;

		// Generate Item HTML via Handle Bars
		var items = productPage.template(data);

		// Append New Items to Container
		productPage.elms.container.append( items );

		// Update Variables to Include All Items
		productPage.elms.items = $( '.product-page .product' );

		// Get the New Items
		var $items = productPage.elms.items.slice( productPage.elms.items.length - productPage.productResultCount, productPage.elms.items.length );

		// Process Items
		productPage.processItems( productPage.elms.items );

		// Add Overlay
		overlay.add( $items );

		// Add Social Links
		socialLinks.add( $items );

		// Add Zoom
		zoom.destroy();
		zoom.add( $items );
		zoom.init();

		// Hide Load More Button if Limit Reached
		productPage.numItems += $items.length;
		productPage.toggleMore();
	},

	processItems: function( $items ) {
		//console.log( "productPage: processItems" );
		$items.each( function( index ) {
			$(this).removeClass('product-fourth').removeClass('product-third').removeClass('product-second');
			if(index % 4 === 0) {
				$(this).addClass('product-fourth');
			}else if(index % 3 === 0) {
				$(this).addClass('product-third');
			}else if(index % 2 === 0) {
				$(this).addClass('product-second');
			}
		});

	},

	processTemplate: function() {
		//console.log( "productPage: processTemplate" );

		var html = productPage.elms.template.html();
		html = html.replace( /\(\(/g, '{{' );
		html = html.replace( /\)\)/g, '}}' );

		productPage.template = Handlebars.compile( html );

	},

	toggleMore: function() {
		//console.log( "productPage: toggleMore" );

		if ( productPage.numItems >= productPage.productResultLimit )
			productPage.elms.more.hide();
		else
			productPage.elms.more.show();

	},


	// ----- EVENT LISTENERS ----- //
	onMoreClick: function( e ) {
		//console.log( "productPage: onMoreClick" );

		e.preventDefault();

		if ( productPage !== productPage.STATE_LOADING ) {

			productPage.changeState( productPage.STATE_LOADING );
			productPage.loadItems();

		}

	}

};